import PropTypes from "prop-types"
import { withPrefix } from "gatsby"

import { MikanSpan } from "./Mikan"

function Button(props) {
  const { buttonText, url, type, customAttributes } = props.data

  const getUrl = () => {
    const nonPrefixedURIs = ["mailto:", "tel:", "#"]
    if (nonPrefixedURIs.some((uri) => url.startsWith(uri))) {
      return url
    }
    return withPrefix(url)
  }

  return (
    <a href={getUrl()} className={`button-new button-new--${type}`} {...customAttributes}>
      <MikanSpan text={buttonText} insertNewLines={false} />
    </a>
  )
}

export default Button

Button.propTypes = {
  buttonText: PropTypes.string,
  url: PropTypes.string,
  type: PropTypes.string,
  iconString: PropTypes.string,
  customAttributes: PropTypes.string,
}

Button.defaultProps = {
  customAttributes: null,
  buttonText: "",
}

export const arrowAfter = `
  position: relative;
  padding-right: 42px; /* make space for the arrow */
  display: inline-block;

  &::after {
    content: "";
    mask: url("/g-static/icons/Button-Arrow.svg");
    mask-size: cover;
    -webkit-mask: url("/g-static/icons/Button-Arrow.svg");
    -webkit-mask-size: cover;
    background-color: currentColor; /* match color from <a> */
    position: absolute;
    right: 0;
    width: 13px;
    height: 13px;
    transform: translate(-24px, 50%);
  }
`
